/**
 *
 * 网格画布工具类
 *
 *
 *
 **/
class gridUtil {
  constructor(telaWidth, telaHeight) {
    this.telaWidth = telaWidth //整体的宽度
    this.telaHeight = telaHeight //整体的高度
    this.colNum = 0 //多少列
    this.rowNum = 0 //多少行
    this.wCol = 0 //单元格的宽度
    this.hRow = 0 //单元格的高度
    this.telaSpace = 0 //相隔的间距
  }
  init(colNum, rowNum, telaSpace) {
    this.colNum = colNum
    this.rowNum = rowNum
    this.wCol = this.telaWidth / colNum
    this.hRow = this.telaHeight / rowNum
    this.telaSpace = telaSpace

    // this.grid(colNum,rowNum)
  }
  update(telaWidth, telaHeight) {
    this.telaWidth = telaWidth
    this.telaHeight = telaHeight
    this.init(this.colNum, this.rowNum, this.telaSpace)
  }

  grid(m, n) {
    if (document.getElementById('grid')) {
      document.getElementById('grid').innerHTML = ''
    }

    var _html = ''

    for (var i = 0; i < n; i++) {
      _html += '<div>'

      for (var j = 0; j < m; j++) {
        if (i == 0) {
          _html += `<div class=\"td\" style='width:${this.wCol}px;height:${this.hRow}px;'>${j}</div>`
        } else {
          if (j == 0) {
            _html += `<div class=\"td\" style='width:${this.wCol}px;height:${this.hRow}px;'>${i}</div>`
          } else {
            _html += `<div class=\"td\" style='width:${this.wCol}px;height:${this.hRow}px;'></div>`
          }
        }
      }

      _html += '</div>'
    }
    setTimeout(() => {
      if (document.getElementById('grid')) {
        document.getElementById('grid').innerHTML = _html
      }
    }, 500)
  }

  initCell(style, data) {
    let telaSpace = this.telaSpace
    if (data.telaSpace || data.telaSpace === 0) {
      telaSpace = data.telaSpace
    }
    style = Object.assign(style, data.style)

    style.left = data.style.positionLeft * this.wCol + telaSpace + 'px'
    style.top = data.style.positionTop * this.hRow + telaSpace + 'px'
    style.width = data.style.width * this.wCol + 'px'
    style.height = data.style.height * this.hRow + 'px'

    return style
  }
}

export default gridUtil
